import { hideAlertMessageOnFocus, SendFormData } from "../../wcl-helpers";

document.addEventListener('DOMContentLoaded', () => {

    if (document.querySelector('.wcl-modal .js-delete-account')) {
        const deleteAccountBtn = document.querySelector('.wcl-modal .js-delete-account');
        const deleteAccountConfirmModal = document.getElementById('wcl-delete-account-popup');
        const deleteAccountConfirmBtn = document.getElementById('wcl-confirm-deletion-button');

        if (deleteAccountConfirmModal) {
            deleteAccountBtn.addEventListener('click', e => {
                e.preventDefault();

                deleteAccountConfirmModal.classList.add('active');
            });

            deleteAccountConfirmBtn.addEventListener('click', e => {
                e.preventDefault();

                const form = deleteAccountConfirmBtn.closest('.wcl-modal-form');
                const modalLayout = form.closest('.wcl-modal-layout');
                const formWrapper = form.closest('.wcl-modal-inner');
                const deleteAccountInput = form.querySelector('#delete_account');
                const successfulDeletionModal = document.getElementById('wcl-successful-deletion-popup');

                // Get user ID
                const userId = form.dataset.userId;

                // Get UI element
                const messageBlock = form.querySelector('.wcl-message-alert');
                const message = form.querySelector('.wcl-message');


                messageBlock.classList.remove('show', 'error', 'success');

                const inputText = deleteAccountInput.value.trim().replace(/\s+/g, '').toLowerCase();

                // Check if the input field is empty
                if (inputText === '') {
                    messageBlock.classList.add('show', 'error');
                    message.textContent = multilanguage_object['Enter the data in the field to delete the account.'];
                    return;
                }

                // Check if the input text matches "deleteaccount"
                if (inputText !== 'deleteaccount' && inputText !== 'supprimerlecompte') {
                    messageBlock.classList.add('show', 'error');
                    message.textContent = multilanguage_object['Entered text is incorrect.'];
                    return;
                }

                console.log('inputText: ', inputText);

                formWrapper.classList.add('loading');

                let formData = new FormData();

                // Adding additional data to the array
                formData.append('user_id', userId);

                SendFormData('delete_account', formData).then(function (res) {
                    formWrapper.classList.remove('loading');

                    let response = JSON.parse(res);

                    if (response.success == '1') {
                        modalLayout.classList.remove('active');
                        successfulDeletionModal.classList.add('active');

                        setTimeout(function () {
                            window.location.reload();
                        }, 4000);
                    } else {
                        throw response.message;
                    }

                }).catch(function (err) {
                    // Error
                    formWrapper.classList.remove('loading');

                    messageBlock.classList.add('show', 'error');
                    message.innerHTML = err;

                    hideAlertMessageOnFocus(form, messageBlock);
                });

            });
        }
    }
});